module.exports = __webpack_public_path__ + "static/media/00 REGGIANA CALCIO - tutti i luoghi.828220e5.svg";